import { calculation, numConvert } from "@/method";
import { setKarte, setOption } from '@/method/analysis';
import request from '@/method/request';
import _ from 'lodash';


export const getChart = async year => {
    const { data } = await request(`/EsCahrt7_2?year=${year}`);
    const dataX = new Array(12).fill(1).map((x, i) => `${i + 1}月`);

    setKarte({
        id: "c1",
        title: "酒店人均受训时间",
        color: ["#E46C0A", "#00B050", '#FE5F5F'],
        yAxis: [
            {
                max: 10, min: 1, interval: 1
            },
            {
                min: 1
            }
        ],
        dataX, dataY: [
            {
                name: "今年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.averageTraining.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
            },
            {
                name: "去年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.averageTraining.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
            },
            {
                yAxisIndex: 1,
                name: "客人满意度",
                data: dataX.map((x, i) => numConvert(_.get(data.ranking.find(_x => _x.month == (i + 1)), 'sort', 0)).toFixed(2))
            }
        ]
    });
    setKarte({
        id: "c2",
        title: "Rooms 房务",
        color: ["#E46C0A", "#00B050", '#FE5F5F'],
        yAxis: {
            max: 10, min: 1, interval: 1
        },
        dataX, dataY: [
            {
                name: "今年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.rooms.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
            },
            {
                name: "去年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.rooms.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
            }
        ]
    });
    setKarte({
        id: "c3",
        title: "Food & Beverage 餐饮",
        color: ["#E46C0A", "#00B050", '#FE5F5F'],
        yAxis: {
            max: 10, min: 1, interval: 1
        },
        dataX, dataY: [
            {
                name: "今年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.fb.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
            },
            {
                name: "去年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.fb.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
            }
        ]
    });
    setKarte({
        id: "c4",
        title: "Administration& General 行政办 、财务、保安",
        color: ["#E46C0A", "#00B050", '#FE5F5F'],
        yAxis: {
            max: 10, min: 1, interval: 1
        },
        dataX, dataY: [
            {
                name: "今年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.general.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
            },
            {
                name: "去年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.general.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
            }
        ]
    });
    setKarte({
        id: "c5",
        title: "Human Resources 人力资源部",
        color: ["#E46C0A", "#00B050", '#FE5F5F'],
        yAxis: {
            max: 10, min: 1, interval: 1
        },
        dataX, dataY: [
            {
                name: "今年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.hr.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
            },
            {
                name: "去年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.hr.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
            }
        ]
    });
    setKarte({
        id: "c6",
        title: "Sales & Marketing 市场销售部",
        color: ["#E46C0A", "#00B050", '#FE5F5F'],
        yAxis: {
            max: 10, min: 1, interval: 1
        },
        dataX, dataY: [
            {
                name: "今年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.sm.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
            },
            {
                name: "去年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.sm.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
            }
        ]
    });
    setKarte({
        id: "c7",
        title: "Engineering 工程部",
        color: ["#E46C0A", "#00B050", '#FE5F5F'],
        yAxis: {
            max: 10, min: 1, interval: 1
        },
        dataX, dataY: [
            {
                name: "今年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.engineering.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
            },
            {
                name: "去年",
                type: "bar",
                data: dataX.map((x, i) => numConvert(_.get(data.engineering.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
            }
        ]
    });

}


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-4/chart/chart.js